<div class="p-4 space-y-3 flex flex-col h-full">

  <div class="flex items-center gap-3 flex-wrap">
    <h2 class="text-sm font-semibold text-gray-900 dark:text-white flex items-center gap-2">
      <i class="fa-solid fa-tag text-app-teal-100"></i>Tickers Master
    </h2>

    <button class="dark-btn dark-btn-sm" (click)="reload()" [disabled]="loading">
      <i class="fa-solid fa-rotate-right mr-1" [class.fa-spin]="loading"></i>Reload
    </button>

    <app-grid-copy-menu [gridApi]="grid?.api"></app-grid-copy-menu>

    <span class="text-xs text-gray-500 dark:text-gray-400 ml-2">
      <strong>{{ rows.length }}</strong> ticker<span *ngIf="rows.length !== 1">s</span>
      in <code class="text-app-teal-100">F2-ADMIN.tickers_master</code>
      <span *ngIf="columnDefs.length > 0" class="ml-1">
        · <strong>{{ columnDefs.length }}</strong> field<span *ngIf="columnDefs.length !== 1">s</span>
      </span>
      <span *ngIf="loadedAt" class="ml-2">
        · loaded {{ loadedAt | date:'MMM d, y, h:mm:ss a' }}
      </span>
    </span>
  </div>

  <p class="text-xs text-gray-500 dark:text-gray-400">
    Read-only view of the master ticker catalog. Columns are derived
    from whatever fields the current documents carry — producer-side
    additions (new sector taxonomy field, etc.) show up on the next
    Reload without any UI change. Filter type per column is inferred
    from sampled values (boolean → checkbox filter, number → range
    filter, string → set filter).
  </p>

  <ag-grid-angular
    class="w-full flex-1 min-h-[520px]"
    [rowData]="rows"
    [gridOptions]="grid.options"
    [statusBar]="grid.statusBar"
    [columnDefs]="columnDefs"
    [theme]="theme">
  </ag-grid-angular>
</div>
